import { render } from "./MenuBar.vue?vue&type=template&id=9f140884&scoped=true"
import script from "./MenuBar.vue?vue&type=script&lang=js"
export * from "./MenuBar.vue?vue&type=script&lang=js"

import "./MenuBar.vue?vue&type=style&index=0&id=9f140884&scoped=true&lang=css"

import exportComponent from "/home/ysm/workspace/webtool/www-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f140884"]])

export default __exports__